import { SET_TOTAL_ACHIEVEMENT } from "./actionTypes";

export const setTotalAchievementCount = (total: number) => ({ type: SET_TOTAL_ACHIEVEMENT, payload: total })
